//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Indicator, Toast } from 'mint-ui'
import { MessageBox } from 'mint-ui'
import { Const } from '@/consts'
import testApi from '@/api/test'
import hebeiSDK from '@/api/hebeiSDK'
import userAPI from '@/api/user'
import examApi from '@/api/exam'
import supervisedApi from '@/api/supervised'
import ImageUtils from '@/utils/imageUtils'
import utils from '@/utils'
import slideverify from '@/components/Newcap.vue'
import FaceRecognition from '@/components/FaceRecognition.vue'
//import JcRange from "@/components/JcRange.vue"
// import dragVerify from "@/components/dragVerify";
import img1 from '@/assets/images/rotate1.jpg'
import img2 from '@/assets/images/rotate2.jpg'
import img3 from '@/assets/images/rotate3.jpg'
import img4 from '@/assets/images/rotate4.jpg'
export default {
    props:{
        datainfos: {
            type:Object,
        }
    },
  data() {
    return {
      isfaceimg:false,       //人脸识别是否拍照
      FaceRecognitionVisible:false,
      result: {},
      compareFile: '',
      mywidth: window.innerWidth,
      compareResult: false,
      lessonid: '',
      courseid: '',
      num: 0,
      authToken: 0,
      uploading: false,
      ratios: '',
      faceShow: false,
      rangeShow: false,
      os: '',
      model: '',
      errNum: 0,
      limitLearningBySuperTimeOut: '',
      superrMsg: false,
      status: false,
      dialogopenV: false,
      puzzePass: {
        visible: false,
        block_y: 20,
        imgurl: img1,
        miniimgurl: img2,
        text: '右滑',
      }, // 滑块字段
        joinClasscode:"0",
        queryinfo:{},
        sumbmitquerys:{
            "target": '',      //人脸上传地址
            "compareMode": 0, //默认0
            "faceCompareResult": 1, //  1 通过  2不通过
            "userCode": "",
            "groupCode": "",
            "courseCode": "",
            "lessonCode": "",
            "vodCode" : "",
            "videoStudyTime" : "",  //人脸识别的位置
            "bizCode" : "",  // 回签  ，通过getFaceCompareConfig 接口获取
        }
    }
  },
  components: {
    // JcRange,
    // dragVerify,
    slideverify,
    FaceRecognition
  },
  created() {
    //接收兄弟组件传参
    this.Brotherfunction()



    this.queryinfo = this.datainfos
    this.sumbmitquerys.userCode = this.datainfos.userCode
    this.sumbmitquerys.groupCode = this.datainfos.groupCode
    this.sumbmitquerys.courseCode = this.datainfos.courseCode
    this.sumbmitquerys.lessonCode = this.datainfos.lessonCode
    this.sumbmitquerys.vodCode = this.datainfos.vodCode
    this.sumbmitquerys.videoStudyTime = this.datainfos.videoStudyTime

    this.hebeiSDKrecord()
    userAPI.getUserInfo().then(resp => {
      this.result = resp.result
      this.ratios = this.result.searchCode
      if (!this.result.avatarurl) {
        MessageBox({
          title: '',
          message: '您尚未上传本人近期照片,请进行资料完善',
          confirmButtonText: '进行资料完善',
          confirmButtonClass: 'button'
        }).then(action => {
          MessageBox.close()
          this.$router.push({
            path: '/personal/setting/complete',
            query: {
              from: 'course/lesson?courseid=' + this.courseid + '&lessonid=' + this.lessonid
            }
          })
        })
      }
    })
    this.lessonid = this.$route.query.lessonid
    this.courseid = this.$route.query.courseid

    let params = {
      params: {
        lessonId: this.$route.query.lessonid
      }
    }
    return supervisedApi.getLessonSupervisedInfo(params).then(resp => {
        //每次调用都会改变joinClasscode验证字符串，一旦改变下次提交数据必须更新，否则会触发人机校验接口
      this.limitLearningBySuperTimeOut = resp.result.limitLearningBySuperTimeOut / 1000
        this.joinClasscode = resp.result.joinClasscode
      this.superrMsg = true
    })
  },
  mounted() {
    // this.num = Math.floor(Math.random() * 10 + 1);
    // if (this.num > 0) {
    //   this.rangeShow = true
    //   this.faceShow = false
    // } else {
    //   this.rangeShow = false
    //   this.faceShow = true
    // }
    this.getImageVerifyCode()
    window.userInfo = this.getUserInfo;                //人脸识别挂载方法
  },
    destroyed(){
    },
    methods: {
    closevideo(){
        this.$EventBus.$emit('Brotherfunction',imgfile);
    },
    //接收兄弟组件的传参
    Brotherfunction(){
      var that = this;
      this.$EventBus.$on('Brotherfunction',(msg)=> {
          if (msg){
              that.$emit('FaceRecognitionfunction',true)
              that.handlePhotoFileChange(msg)
          }
      });
    },

    getImageVerifyCode() {
      let _this = this
      userAPI.getImageVerifyCode().then(resp => {
        console.log(resp, "scuessscuessscuessscuessscuessscuessscuess")
        this.rangeShow = true
        this.faceShow = false
        const imgobj = {
          bigImage: 'data:image/png;base64,' + resp.result.bigImage, // 大图
          smallImage: 'data:image/png;base64,' + resp.result.smallImage, // 小图
          yHeight: resp.result.yHeight * (document.documentElement.clientWidth - 40) * 300 / 480 / 300// 初始y坐标
        }
        _this.puzzePass.block_y = imgobj.yHeight
        console.log(imgobj.yHeight, "imgobj.yHeightimgobj.yHeightimgobj.yHeight")
        _this.puzzePass.imgurl = imgobj.bigImage
        _this.puzzePass.miniimgurl = imgobj.smallImage
        _this.dialogopenV = true
        localStorage.setItem("resetBlock_y", _this.puzzePass.block_y)
        const h = Math.floor((Math.random() * 150))
        if(_this.$refs.dialogopen){
         _this.$refs.dialogopen.reset(h)
        }

        //_this.$refs.dialogopen && _this.$refs.dialogopen.reset(_this.puzzePass.block_y)
      }).catch(resp => {
        console.log(resp, "errorerrorerrorerrorerrorerrorerrorerrorerrorerrorerrorerror")
        this.rangeShow = false
        this.faceShow = true
      })
    },
    onFail() {
      console.log('fail')
    },
    // 刷新验证码
    onRefresh() {
      this.puzzePass.imgurl = ''
      this.puzzePass.miniimgurl = ''
      this.puzzePass.block_y = 0
      //this.dialogopenV=false

      this.getImageVerifyCode()
    },
    // 验证码拉动距离返回
    onSuccess(left) {
      let _this = this
      left = parseInt(left * 480 / (document.documentElement.clientWidth - 40))
      console.log('succss', left)
      userAPI.verifyImageCode("?moveLength=" + left).then(resp => {
        //_this.$refs.dialogopen.handleSuccess()
        _this.rangeShow = false
        _this.faceShow = true
        _this.authToken = resp.result
        MessageBox({
          title: '',
          message: '验证成功',
          confirmButtonText: '提示',
          confirmButtonClass: 'button'
        }).then(action => {
          _this.uploadPhoto()
        })
        //}, 5000);
        //this.$refs.upload.dispatchEvent(new MouseEvent('click'))
      }).catch(resp => {
        //_this.dialogopenV=false
        _this.$refs.dialogopen.handleFail()
        MessageBox({
          title: '',
          message: '验证失败，请重新拖动滑块验证',
          confirmButtonText: '提示',
          confirmButtonClass: 'button'
        }).then(action => {
          _this.onRefresh()
        })

      })
    },
    // errorFun() {
    //   this.showFailDialog("请拖动滑块到指定位置，请重试")
    // },
    // successFun() {
    //   MessageBox({
    //     title: '',
    //     message: '验证通过',
    //     confirmButtonText: '提示',
    //     confirmButtonClass: 'button'
    //   }).then(action => {
    //     this.rangeShow = false
    //     this.faceShow = true
    //   })
    // },
    emitChange() {
      let supervisedResult = {
        compareFile: this.compareFile,
        compareResult: this.compareResult,
        joinClasscode: this.joinClasscode
      }
      this.$emit('change', supervisedResult)
    },
    goBack() {
      this.$router.push({
        path: '/index/courseInfo',
        query: {
          lessonid: this.lessonid,
          courseid: this.courseid
        }
      })
    },

    uploadPhoto() {
        //this.clickFunc()
        //this.$refs.photoFile.click()
        console.log('执行uploadPhoto()')
        this.$emit('FaceRecognitionfunction',false)      //人脸识别

      // console.log(this.$refs.photoFile, "photoFilephotoFilephotoFilephotoFilephotoFilephotoFilephotoFile")
      //this.$refs.photoFile.dispatchEvent(new MouseEvent('click'))
      // const trigger = () => {
      //   const $el = this.$refs.photoFile
      //   $el.dispatchEvent(new Event('click'));
      // }
      // if (!this.$refs.photoFile) {
      //   this.$nextTick(trigger.bind(this))
      // } else {
      //   trigger();
      // }
    },
      //给app传参，判断安卓IOS
      clickFunc(item) {
          // alert(item.contracttitle);
          const u = navigator.userAgent;
          const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          if (isiOS) {
              //vue调用iOS方法，且传值给iOS （iOS 方法名为 onItemClick）
              window.webkit.messageHandlers.onItemClick.postMessage('ios');
          } else {
              //vue调用Android方法，且传值给Android （Android方法名为 onItemClick）
              // $App.onItemClick('000');
              window.android.onItemClick('android');
          }
      },
      //获取监管记录
      hebeiSDKrecord(){
          hebeiSDK.getFaceCompareConfig({
              params:this.queryinfo
          }).then((res)=>{
              console.log(res)
              if (res.statusCode == 200){
                  var res = JSON.parse(res.result)
                  this.sumbmitquerys.bizCode = res.bizCode
              }
          })
      },
      //人脸识别--接收app传来的参数
      getUserInfo(json){
          console.log(json)
          //接收传来的人脸识别地址target，调用thirdFaceComparefunction()
          // this.sumbmitquerys.target = json.target
          // this.thirdFaceComparefunction()
      },

      // 提交人脸识别突破记录
      thirdFaceComparefunction(){
          hebeiSDK.getFaceCompareConfig({
              params:this.sumbmitquerys
          }).then((res)=>{
              var res = JSON.parse(res.result)
              console.log(res)
          })
      },

    openTimeOutDialog() {
      MessageBox({
        title: '提示',
        message: '上传照片超时，点击确定返回',
        confirmButtonText: '确定',
        confirmButtonClass: 'button'
      }).then(action => {
        MessageBox.close()
        this.goBack()
      })
    },
    handlePhotoFileChange(oldFile) {
      let me = this
      this.uploading = true
      // const oldFile = this.$refs.photoFile.files[0]
          console.log(oldFile)
          let ratio = 0.5
          localStorage.setItem('beforeCompressFileLength', oldFile.size)
          ImageUtils.imageProcess(oldFile, me.ratios, file => {
            if (!file) {
              localStorage.setItem('afterCompressFileLength', 'file为空')
              MessageBox({
                title: '提示',
                message: '照片处理失败，请重试',
                confirmButtonText: '确定',
                confirmButtonClass: 'button'
              }).then(action => {
                MessageBox.close()
                this.goBack()
              })
            } else if (file == 'fileErr') {
              MessageBox({
                title: '提示',
                message: '照片处理有损，请重试',
                confirmButtonText: '确定',
                confirmButtonClass: 'button'
              }).then(action => {
                MessageBox.close()
                this.goBack()
              })
            } else {
              localStorage.setItem('afterCompressFileLength', file.size)
              console.log('压缩后的尺寸为:', file.size)
              let t = setTimeout(this.openTimeOutDialog, 15000)
              // this.$refs.photoFileForm.reset();
              examApi.comparefaceReturnFile({// --
                params: {
                  facepic: file,
                  facepicTime: oldFile.lastModified,
                  facepicSource: 'camera',
                  locaTpme: new Date().getTime(),
                  os: navigator.userAgent,
                  model: 'this',
                  authToken: me.authToken
                }
              }).then(resp => {
                clearTimeout(t)
                // localStorage.setItem("comparefaceReturnFile",file.size)
                let result = resp[Const.RESP_RESULT]
                this.compareResult = result.compareResult
                this.compareFile = result.fileResult.objectid
                if (this.compareResult === true) {
                  console.log('人脸识别通过')
                  utils.save('onFaceCheck' + this.lessonid + '' + this.courseid, new Date().getTime())
                  this.emitChange()
                } else {
                  // alert("验证不通过begin")
                  // debugger
                  // localStorage.setItem("验证不通过begin", resp.message)
                  if (this.errNum >= 2) {
                    this.errNum = 0
                    MessageBox({
                      title: '提示',
                      message: '已尝试验证超过两次，请关闭美颜功能再试！',
                      confirmButtonText: '确定',
                      confirmButtonClass: 'button'
                    }).then(action => {
                      me.errNum = 0
                      this.uploading = false
                      MessageBox.close()
                      this.goBack()
                    })
                  } else {
                    this.errNum = this.errNum + 1
                    this.showFailDialog(resp.message)
                  }
                  // alert("验证不通过end")
                  // localStorage.setItem("验证不通过end", resp.message)
                }
              }).catch(resp => {
                // debugger
                // alert("验证异常begin")
                // localStorage.setItem("验证异常begin", resp.message)
                clearTimeout(t)
                // localStorage.setItem("验证异常ing", resp.message)
                // localStorage.setItem("验证异常", resp.message)
                if (this.errNum >= 2) {
                  this.errNum = 0
                  MessageBox({
                    title: '提示',
                    message: '已尝试验证超过两次，请关闭美颜功能再试！',
                    confirmButtonText: '确定',
                    confirmButtonClass: 'button'
                  }).then(action => {
                        me.errNum = 0
                        this.uploading = false
                        MessageBox.close()
                        location.reload()
                        this.goBack()
                  })
                } else {
                  this.errNum = this.errNum + 1
                  this.showFailDialog(resp.message)
                }
                // alert("验证异常end")
                // localStorage.setItem("验证异常end", resp.message)
              })
            }
          })
    },
     showFailDialog(message) {
        var that = this;
            MessageBox.confirm(message == undefined ? '请清除缓存重新尝试!':message + '<br/>没有通过验证,请重新验证<br/>您要继续验证吗？', '温馨提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                closeOnClickModal: false,
                type: 'info'
            }).then(action => {
                that.uploading = false
                that.uploadPhoto()
            }).catch(() => {
                that.$router.push({ path: '/index/courseInfo', query: { courseid: this.$route.query.courseid } })
            })


    },

    doTest() {
      const courseId = this.courseId

      if (!courseId) {
        return
      }

      /// ///////////////////////////////////
      this.$router.push({
        path: '/exam',
        query: {
          courseId: courseId,
          examType: '1'
        }
      })
      /// ///////////////////////////////////

      // examApi.startExam({
      //     params: {
      //         courseid: courseId,
      //         examtype: 'REAL'
      //     }
      // }).then((resp) => {
      //     const result = resp[Const.RESP_RESULT];
      //     if (result === true || (result && result[Const.RESP_RESULT] === true)) {
      //         this.$router.push({path: '/exam', query: {
      //             courseId: courseId,
      //             examType: '1'
      //         }});
      //     } else {
      //         Toast('很抱歉，您暂时不能进行考试');
      //     }
      // }).catch((resp) => {
      //     // Toast(resp[Const.RESP_MESSAGE] || '出错了 ...');
      //     // this.buttonEnabled.test = true;
      //     if (resp.statusCode == '200') {
      //         Toast(resp[Const.RESP_MESSAGE] || '出错了 ...');
      //     }
      // });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/idverify4Unit.vue